import { FieldPath, FieldValues, UseFormRegister } from 'react-hook-form'
import { Box, Typography } from '@mui/material'
import { handleOnKeyDown } from 'src/utils/Form'
import theme from 'src/styles/theme'
import * as S from './SimpleInput.styles'

interface SimpleInputProps<T extends FieldValues, K extends FieldPath<T>> {
  register: UseFormRegister<T>;
  onSubmit?: () => void
  inputName: K;
  dataTestId: string;
  hasError?: boolean;
  errorMessage?: string | undefined;
  type?: string;
  width?: string;
  backgroundColor?: keyof typeof theme.colors;
}

const SimpleInput = <T extends FieldValues, K extends FieldPath<T>>(
  scanCodeInput: SimpleInputProps<T, K>,
) => {
  const {
    register,
    onSubmit,
    inputName,
    dataTestId,
    hasError,
    errorMessage,
    backgroundColor,
    width,
    type = 'number',
  } = scanCodeInput

  return (
    <Box sx={{ width: width || '100%' }}>
      <S.StyledInputBase
        inputProps={{ ...register(inputName), 'data-testid': dataTestId }}
        onKeyDown={(e) => {
          if (onSubmit) {
            handleOnKeyDown(e, '', onSubmit)
          }
        }}
        id={inputName}
        autoFocus
        type={type}
        sx={{
          '& input': {
            textAlign: 'center',
          },
        }}
        backgroundColor={backgroundColor}
        width={width}
      />
      {
          hasError && (
            <Typography
              color='red'
              variant='caption'
            >
              {errorMessage}
            </Typography>
          )
        }
    </Box>
  )
}

export default SimpleInput
